// extracted by mini-css-extract-plugin
export var postsContainer = "styles-module--postsContainer--RKcRl";
export var firstCard = "styles-module--firstCard--N7LSE";
export var backAndForthRight = "styles-module--backAndForthRight--0Iqv8";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--Kkvoe";
export var animateBg = "styles-module--animateBg--FBeBX";